import { RollbackOutlined, SyncOutlined } from '@ant-design/icons';
import { FloatButton } from 'antd';

const LayoutFloatButton = () => {
  return (
    <div className="hidden md:block">
      <FloatButton.Group shape="square" style={{ right: 48, bottom: 120 }}>
        <FloatButton
          icon={<RollbackOutlined />}
          onClick={() => window.history.back()}
        />
        <FloatButton
          icon={<SyncOutlined />}
          onClick={() => window.location.reload()}
        />
      </FloatButton.Group>
    </div>
  );
};

export default LayoutFloatButton;
